document.addEventListener('alpine:init', () => {
  const previousPage = localStorage.getItem('currentPage')
  if (previousPage && previousPage !== window.location.href) {
    localStorage.setItem('previousPage', previousPage)
  }
  localStorage.setItem('currentPage', window.location.href)
  Alpine.store('main', {
    cart: [],
    checkout: '',
    selectVariantWarning: false,
    showCartPopup: false,
    bundleMatches: [],
    init () {
      let storeState = localStorage.getItem('storeState')
      if (storeState) {
        storeState = JSON.parse(storeState)
        this.cart = storeState.cart
        this.checkout = storeState.checkout
        if (!this.checkout) { 
            this.clearCheckout()
        }
        this.bundleMatches = storeState.bundleMatches || []
        if (!Array.isArray(this.bundleMatches)) { this.bundleMatches = [] }
        this.checkCartExpiration()
        if (!sessionStorage.getItem('cartChecked')) {
          this.getCheckout()
          sessionStorage.setItem('cartChecked', 'true')
        }
      }
      Alpine.effect(() => {
        localStorage.setItem('storeState', JSON.stringify({
          cart: this.cart,
          checkout: this.checkout,
          bundleMatches: this.bundleMatches
        }))
      });
    },
    isBundleItem (item) {
      return this.bundleMatches.find(el => el.children.find(child => child.id === item.id))
    },
    shippingCost() {
      if (!this.checkout) { return 0 }
      if (this.checkout.quote.totals.grand_total >= 89) { return 0 }
      else {
        return 5.95
      } 
    },
    totalCartItems () {
      let quantity = 0
      for (let index = 0; index < this.cart.length; index++) {
        const element = this.cart[index];
        quantity += element.quantity
      }
      return quantity
    },
    checkCartExpiration () {
      if (this.checkout && this.checkout.created_at) {
        const createdDate = new Date(this.checkout.created_at)
        const now = new Date()
        const diff = now - createdDate
        const diffInDays = diff / (1000 * 60 * 60 * 24)
        if (diffInDays > 14) {
          this.clearCheckout()
        }
      }
    },
    clearCheckout() {
      this.cart = []
      this.checkout = ''
    },
    totalWithoutShipping() {
      if (!this.checkout) { return 0 }
      let total = 0
      for (let index = 0; index < this.checkout.products.length; index++) {
        const element = this.checkout.products[index];
        total += element.price_incl
      }
      return total
    },
    async getCheckout (cartPageInitialized) {
      if (!this.checkout && !this.checkout.id) { return }
      try {
        const response = await fetch(`/api/checkouts/${this.checkout.id}`, {
          method: 'GET'
        })
        const json = await response.json()
        if (json.error) {
          this.clearCheckout()
          return
        }
        this.checkout = json
        this.cart = json.products 

        // remove payment fee
        const findPaymentFee = this.cart.find(el => el.variant_id === 296361881)
        if (findPaymentFee) {
          this.removeFromCart(findPaymentFee.id)
        }
      }
      catch {
        this.clearCheckout()
      }
      if (cartPageInitialized) {
        this.viewCartDatalayerEvent()
      }
    },
    toCheckout () {
      const url = new URL(window.location.href)
      window.location.href = url.origin + '/checkout/' + this.checkout.id + '?step=contact_information'
    },
    async addToCart (variants, showCartPopup, bundleParent) {
      if (variants.filter(el => el.variant_id).length === 0) {
        this.selectVariantWarning = true
        return
      }
      const response = await fetch('/api/cart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.checkout.id || null,
          order_id: this.checkout.order_id || null,
          billing_address: {
            country: this.checkout.billing_address &&  this.checkout.billing_address.country ? this.checkout.billing_address.country : ''
          },
          bundleParent,
          variants
        })
      })
      const json = await response.json()
      if (!response.ok) {
        window.dispatchEvent(new CustomEvent('show-error-dialog', {
          detail: 'Kon product niet toevoegen aan winkelwagen'
        }))
        return
      }
      this.checkout = json.checkout
      this.cart = json.checkout.products
      if (json.checkout.addedToCart && json.checkout.addedToCart.filter(el => el.error).length > 0) {
        window.dispatchEvent(new CustomEvent('show-error-dialog', {
          detail: 'Kon product niet toevoegen aan winkelwagen'
        }))
      }
      else if (json.checkout.addedToCart) {
        if (bundleParent) {
          this.bundleMatches.push({
            parent: bundleParent,
            children: json.checkout.addedToCart.filter(el => el.url !== bundleParent)
          })
        }
        if (showCartPopup) { this.showCartPopup = true }
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "add_to_cart",
          is_bundle: bundleParent ? true : false,
          ecommerce: {
            items: json.checkout.addedToCart.map((el, i) => {
              return {
                id: window.selectProductId({ id: el.variant_id, sku: el.sku }, voleroAnalyticsProductIdType),
                item_id: window.selectProductId({ id: el.variant_id, sku: el.sku }, voleroAnalyticsProductIdType),
                item_name: el.title,
                currency: 'EUR',
                quantity: 1,
                index: i,
                price: el.base_price_incl,
                item_brand: el.brand_name,
                item_variant: el.variant_id,
                va: el.variant
              }
            })
          }
        });
        
       
        window.sqzlPushWrapper({
          "event": "AddToCart",
          "products": json.checkout.addedToCart.map((el, i) => {
            console.log(el)
            return {
              id: el.sku,
              sku: el.sku,
              name: el.fulltitle,
              quantity: 1,
              price: el.price_incl,
            }
          })
        });
      }
     
      if (response.ok) {
        return true
      }
      else {
        return false
      }
    },
    async changeQuantity (variant_id, quantity) {
      const response = await fetch('/api/cart', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.checkout.id,
          order_id: this.checkout.order_id || null,
          variant_id,
          quantity
        })
      })
      const json = await response.json()
      this.checkout = json.checkout
      this.cart = json.checkout.products
      if (this.checkout.changedQuantity === false) {
        window.dispatchEvent(new CustomEvent('show-error-dialog', {
          detail: 'Kon het aantal niet wijzigen. Product heeft waarschijnlijk geen extra voorraad.'
        }))
      }
    },
    async removeFromCart (variant_id) {
      const response = await fetch('/api/cart', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.checkout.id,
          order_id: this.checkout.order_id || null,
          variant_id
        })
      })
      const json = await response.json()
      const removedProd = this.cart.find(el => el.id === variant_id)
      this.removeFromCartDatalayerEvent(removedProd)
      this.checkout = json.checkout
      this.cart = json.checkout.products
    },
    removeFromCartDatalayerEvent (removedProd) {
      try {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: [{
            id: window.selectProductId({ id: removedProd.variant_id, sku: removedProd.sku }, voleroAnalyticsProductIdType),
            item_id: window.selectProductId({ id: removedProd.variant_id, sku: removedProd.sku }, voleroAnalyticsProductIdType),
            item_name: removedProd.title,
            item_variant: removedProd.variant_id,
            quantity: removedProd.quantity,
            currency: 'EUR',
            index: 1,
            price: removedProd.price_incl,
            item_brand: removedProd.brand_name
          }]
        }
      });
       
        window.sqzlPushWrapper({
          "event": "RemoveFromCart",
          "products": [{
            id: removedProd.sku,
            sku: removedProd.sku,
            name: removedProd.title,
            quantity: removedProd.quantity,
            price: removedProd.base_price_incl,
          }]
        });
      }
      catch (error) {
        console.log(error)
      }
    },
    viewCartDatalayerEvent () {
      try {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "view_cart",
          value: this.checkout.quote.price_incl,
          ecommerce: {
            items: this.cart.map((el, i) => {
              return {
                id: window.selectProductId({ id: el.variant_id, sku: el.sku }, voleroAnalyticsProductIdType),
                item_id: window.selectProductId({ id: el.variant_id, sku: el.sku }, voleroAnalyticsProductIdType),
                item_name: el.title,
                item_variant: el.variant_id,
                quantity: el.quantity,
                index: i,
                currency: 'EUR',
                price: el.price_incl,
                item_brand: el.brand_name
              }
            })
          }
        });
      }
      catch {
        console.log('datalayer failed')
      }
    }
  })
  Alpine.data('errorDialog', () => ({
    error: '',
    show: false,
    showErrorDialog(message) {
        this.error = message
        this.show = true
        setTimeout(() => {
          this.show = false
        }, 10000);
    }
  }))
})